import styled from 'styled-components';
import { Row, Alert } from 'react-bootstrap';

export const Titulo = styled.h2`
  margin-bottom: 1.5rem;
  color: #343a40;
  font-weight: 600;
`;

export const FormSection = styled.div`
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 0.6rem;
  margin-bottom: 1rem;

  h5 {
    margin: 0 0 1rem 0;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #dee2e6;
    color: #495057;
    font-weight: 600;
  }
`;

export const FormRow = styled(Row)`
  margin-bottom: 0.5rem;
`;

export const ActionsBar = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #dee2e6;
`;

export const StatusAlert = styled(Alert)`
  margin-bottom: 1.5rem;
`;

export const MedicamentoCard = styled.div`
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  padding: 1rem;
  margin-bottom: 0.5rem;
`;
